import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const routesConnectedApps: RouteMetaConfig[] = [
  {
    path: '/connected-apps',
    name: routeNames.connectedApps,
    component: () => import('./views/ConnectedAppsListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'connected_apps.view',
    },
    children: [
      buildModalRoute(
        {
          name: routeNames.connectedAppsSensorberg,
          path: 'sensorberg/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsSensorbergView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsSCSolutions,
          path: 'sc-solutions/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsScSolutionView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsNoke,
          path: 'noke/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsNokeView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsSedisto,
          path: 'sedisto/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          component: () => import('./views/ConnectedAppsSedistoView.vue'),
          props: true,
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsSignable,
          path: 'signable/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          component: () => import('./views/ConnectedAppsSignableView.vue'),
          props: true,
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsSensorbergOcb,
          path: 'sensorberg-ocb/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          component: () => import('./views/ConnectedAppsSensorbergOcbView.vue'),
          props: true,
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsSignableHowToSetup,
          path: 'signable-how-to-setup',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          component: () =>
            import('./views/ConnectedAppsSignableHowToSetup.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsStripeIdCheck,
          path: 'id-check/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsStripeIdCheckView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsOpenTech,
          path: 'open-tech/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsOpenTechView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsPaxtonNet2,
          path: 'paxton-net2/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsPaxtonNet2View.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsBearBox,
          path: 'bear-box/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsBearBoxView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsTapKey,
          path: 'tap-key/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsTapKeyView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsAzureAd,
          path: 'sso-azure-ad/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsAzureAdView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsVisor,
          path: 'visor/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: (route) => ({ id: route.params.id, type: 'visor' }),
          component: () => import('./views/ConnectedAppsConnectionsView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsVisorSetup,
          path: 'visor/:id/setup/:connectionId?',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () => import('./views/ConnectedAppsVisorSetupView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsKinnovisAccess,
          path: 'kinnovis-access/:id',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: (route) => ({ id: route.params.id, type: 'kinnovis_access' }),
          component: () => import('./views/ConnectedAppsConnectionsView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.connectedAppsKinnovisAccessSetup,
          path: 'kinnovis-access/:id/setup/:connectionId?',
          meta: {
            requiresAuth: true,
            permission: 'connected_app_connections.create',
          },
          props: true,
          component: () =>
            import('./views/ConnectedAppsKinnovisAccessSetupView.vue'),
        },
        { fullscreen: false }
      ),
    ],
  },
];

export const connectedAppsRoutesFactory = {
  connectedAppsList() {
    return {
      name: routeNames.connectedApps,
    };
  },
  getAddConnectionRoute(setupRouteName: string, connectedAppId: number) {
    return {
      name: setupRouteName,
      params: {
        id: connectedAppId,
      },
    };
  },
  getEditConnectionRoute(
    setupRouteName: string,
    connectedAppId: number,
    connectionId: number
  ) {
    return {
      name: setupRouteName,
      params: {
        id: connectedAppId,
        connectionId,
      },
    };
  },
  connectedAppsSignable(signableId: number) {
    return {
      name: routeNames.connectedAppsSignable,
      params: {
        id: signableId,
      },
    };
  },
};
